export const getAvailableSmsCount = async () => {
  return 101;
};
